import { createSelector } from '@reduxjs/toolkit';

const partnerObject = (state = {}) => state.product;

export const getLoading = createSelector(
  partnerObject,
  (groupData) => groupData.ui.loading,
);

export const getPartnerLoading = createSelector(
  partnerObject,
  (groupData) => groupData.ui.loadingPartner,
);

export const getSellers = createSelector(
  partnerObject,
  (groupData) => groupData.sellers,
);

export const getSellersProducts = createSelector(
  partnerObject,
  (groupData) => groupData.data,
);
export const getSellersLocations = createSelector(
  partnerObject,
  (groupData) => groupData.delivery,
);

export const getSellersProduct = createSelector(
  partnerObject,
  (groupData) => groupData.products,
);

export const getPageStats = createSelector(
  partnerObject,
  (groupData) => groupData.ui.stats,
);

export const getCart = createSelector(partnerObject, (groupData) => groupData.cart);

export const getDeliveryLocation = createSelector(
  partnerObject,
  (groupData) => groupData.delivery_location,
);
